/** Bounded telemetry only: never accept submitted URLs, prompts, or auth tokens. */
export const analyticsSchemaVersion = 2;
export const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
export const campaignDimensions: Record<string, readonly string[]> = {
  landing_variant: ['browser_check_v1'], entry_mode: ['cloud'], selected_mode: ['cloud', 'screen', 'agent'],
  landing_offer_id: ['standard_cloud_credits'], landing_offer_version: ['2026_09_30'],
  entry_device: ['phone', 'tablet', 'desktop'], entry_browser: ['safari', 'chrome', 'firefox', 'edge', 'reddit', 'other'],
};
export const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function safeFunnelContext(input: unknown): Record<string, string | boolean> {
  if (!input || typeof input !== 'object' || Array.isArray(input)) return {};
  const source = input as Record<string, unknown>;
  const result: Record<string, string | boolean> = {};
  for (const prefix of ['', 'first_', 'session_']) for (const key of campaignKeys) {
    const value = source[`${prefix}${key}`];
    if (typeof value === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(value)) result[`${prefix}${key}`] = value;
  }
  for (const key of ['anonymous_id', 'auth_attempt_id']) {
    if (typeof source[key] === 'string' && uuidPattern.test(source[key])) result[key] = source[key];
  }
  for (const [key, values] of Object.entries(campaignDimensions)) {
    if (typeof source[key] === 'string' && values.includes(source[key] as string)) result[key] = source[key] as string;
  }
  if (source.is_test === true) result.is_test = true;
  return result;
}
export function eventAttribution(input: unknown) {
  const { anonymous_id: _anonymous, ...properties } = safeFunnelContext(input);
  return properties;
}
export async function analyticsRunId(recordingId: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(`rill-analytics-run-v1:${recordingId}`));
  return Array.from(new Uint8Array(digest)).map(byte => byte.toString(16).padStart(2, '0')).join('').slice(0, 32);
}
